import React from 'react'
const SortArrow = ({height}: {height: number}) => {
    return (
        <svg
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth="3"
            stroke="#142745"
            fill="none"
            height={height}
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <line x1="19.29" y1="9.1" x2="19.29" y2="54.9"></line>
                <polyline points="32.14 21.31 19.26 9.1 7.53 21.31"></polyline>
                <line x1="43.67" y1="54.9" x2="43.67" y2="9.1"></line>
                <polyline points="56.52 42.69 43.64 54.9 31.91 42.69"></polyline>
            </g>
        </svg>
    )
}
export default SortArrow
